import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import { USERS_SEARCH } from 'common/endpoints'
import { chat } from 'store/reducers/userProfile/actions'
import StyledEmptyState from './StyledEmptyState'
import emptyChat from 'assets/images/empty-chat.svg'

const getUsers = () =>
  axios.get(`${USERS_SEARCH}?filters=matches&withGallery=on&pageSize=3`).then(r => r.data.accounts)

const EmptyState = () => {
  const [users, setUsers] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    getUsers().then(setUsers)
  }, [])

  return (
    <StyledEmptyState className="empty-state">
      <img className="empty-logo" src={emptyChat} />
      <h3>Hey, it looks like you still have no chats started...</h3>
      <p>no one on this site is shy, so why don't you try to break the ice with these members?</p>
      <div className="users">
        {users.map(({ media, screenName, location, nickname }) => (
          <div key={nickname} className="user" onClick={() => dispatch(chat({ nickname }))}>
            <div className="photo" style={{ backgroundImage: `url(${media[0].uri.replace('{0}', 'medium')})` }}></div>
            <div className="screen-name">{screenName}</div>
            <div className="location">{`${location.city.name}, ${location.country.name}`}</div>
          </div>
        ))}
      </div>
    </StyledEmptyState>
  )
}

export default EmptyState
